import React from 'react';
import styled from 'styled-components';
import { CELL_SIZE } from '../utils/constants';

// 单元格样式
const StyledCell = styled.div`
  width: ${CELL_SIZE}px;
  height: ${CELL_SIZE}px;
  background: ${props => (props.color ? props.color : 'transparent')};
  border: ${props => (props.color ? '4px solid' : '1px solid')};
  border-bottom-color: ${props => (props.color ? 'rgba(0, 0, 0, 0.3)' : 'rgba(80, 80, 80, 0.1)')};
  border-right-color: ${props => (props.color ? 'rgba(0, 0, 0, 0.3)' : 'rgba(80, 80, 80, 0.1)')};
  border-top-color: ${props => (props.color ? 'rgba(255, 255, 255, 0.2)' : 'rgba(80, 80, 80, 0.1)')};
  border-left-color: ${props => (props.color ? 'rgba(255, 255, 255, 0.2)' : 'rgba(80, 80, 80, 0.1)')};
`;

const Cell = ({ type, colors }) => {
  return (
    <StyledCell color={type > 0 ? colors[type - 1] : 'none'} />
  );
};

export default React.memo(Cell);